import React from 'react'
import { PreviewStackContainer } from '../preview-order/PreviewStackContainer'
import PropaneTankOutlinedIcon from '@mui/icons-material/PropaneTankOutlined';
import { Avatar, Box, Grid, Paper, Stack, Typography } from '@mui/material';
import { customStyles, justifyCenter, spaceBetween } from '../../../styles';
import { SecondaryText } from '../../helpers/text/SecondaryText';
import image from '../../../assets/images/user.png'
import { CaptionText, SmallText } from '../../helpers';
import StarRoundedIcon from '@mui/icons-material/StarRounded';const style = {
   color: customStyles.colors.main
}
export const ProductOrder = () => {
  return (
   //  <PreviewStackContainer text="">
     
   <Stack sx={{ position: 'absolute', left: '50%', bottom: '5%', transform: 'translateX(-50%)', width: '90%' }}>
      <SmallText text="Detalles del Aliado" bold/>
      <Paper sx={ { padding: 1, }}>
         <Box sx={{ display: 'flex' }}>
            <Avatar src={image} sx={{ marginRight: 2 }}/>
            <Box>
               <SmallText text="Paco Alameda" bold/>
               <CaptionText text='4.9(20)' icon={ <StarRoundedIcon fontSize='small' sx={{ color: customStyles.colors.yellow, marginRight: 2 }}/> } sx={{ display: 'flex', alignItems: 'center' }}/>
            </Box>
         </Box>
         <Box sx={{ display: 'flex' }}>
            <PropaneTankOutlinedIcon fontSize='large' sx={{ marginRight: 2 }}/>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
               <SmallText text="Cilindro" sx={{ marginRight: 2 }}/>
               <CaptionText text='4pz' sx={{ display: 'flex', alignItems: 'center' }}/>
            </Box>
         </Box>
      </Paper>
   </Stack>
   //  </PreviewStackContainer>
  )
}
